import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { RadioButtonComponent } from '../radio-button/radio-button.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorBase } from '../../../core/control-value-accessor-base';

@Component({
    selector: 'sc-radio-button-list',
    imports: [],
    templateUrl: './radio-button-list.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: RadioButtonListComponent,
        },
    ]
})
export class RadioButtonListComponent
  extends ControlValueAccessorBase<number | string>
  implements AfterContentChecked
{
  private radioButtonList: RadioButtonComponent[] = [];
  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  ngAfterContentChecked() {
    const radioButtonComponentControl = this.radioButtonList.find(
      (radioButtonComponent) => {
        return radioButtonComponent.radioOption.value === this.value;
      }
    );

    if (radioButtonComponentControl) {
      radioButtonComponentControl.isChecked.set(true);
    }
  }

  addRadioButtonComponent(radioButtonComponent: RadioButtonComponent) {
    this.radioButtonList.push(radioButtonComponent);
  }

  updateRadioButtonComponent(radioButtonComponent: RadioButtonComponent) {
    this.radioButtonList.forEach((radioButtonComponent) =>
      radioButtonComponent.isChecked.set(false)
    );
    radioButtonComponent.isChecked.set(true);
    this.value = radioButtonComponent.radioOption.value;
    this.writeValue(this.value);
    this.onChange(this.value);
    this.cdr.detectChanges();
  }
}
